import Menu from './Compartido/Menu.jsx';
import Cabecera from './Inicio/Cabecera.jsx';
import Destinos from './Inicio/Destinos.jsx';
import TipoBarcos from './Inicio/TipoBarcos.jsx';
import Formulario from './Inicio/Formulario.jsx';
import Footer from './Compartido/Footer.jsx';
import Scripts from './Compartido/Scripts.jsx';

const Inicio = (props) => {
    return (
        <main>
            <Menu
                lang={props.lang}
                meta_titulo={props.meta_titulo}
                meta_descripcion={props.meta_descripcion}
                meta_keywords={props.meta_keywords}
                ruta={props.ruta}
                config={props.websgrupo}
                pagina="index"
                destinos={props.destinos}
                tiposcasas={props.tiposcasas}
            />
            <Cabecera
                lang={props.lang}
                destinos={props.destinos}
                tiposcasas={props.tiposcasas}
            />
            <Destinos
                lang={props.lang}
                destinos={props.destinos}
                ruta={props.ruta}
            />
            <TipoBarcos
                lang={props.lang}
                tiposcasas={props.tiposcasas}
            />
            <Formulario
                lang={props.lang}
                datos={props.websgrupo}
            />
            <Footer
                lang={props.lang}
                datos={props.websgrupo}
            />
            <Scripts />
        </main>
    )
}
export default Inicio;

